module.exports = __webpack_public_path__ + "static/scale-model-of-the-awakening-in-alexandria-virginia-3ebfec75ad71b7ca276b013e81a5bf3f.png";